module.exports = function getParty(documents = []) {
    return documents.map(doc => {
        return {
            id: doc.Id,
            documentType: doc.DocumentType,
        };
    });
};
